import * as api from "../api/index";
import {
  START_LOADING,
  END_LOADING,
  FETCH_ITEMS,
  FETCH_ITEMS_USER,
  ADD_NEW_ITEM,
  ADD_NEW_ITEMS,
  UPDATE_ITEM,
  DELETE_ITEM,
  DELETE_ITEMS_BY_CATEGORY,
  ADD_NEW_STOCK,
  ADD_NEW_STOCKS,
  CREATE_FUTURE_PRICE_LIST,
  FETCH_FUTURE_PRICE_LIST,
  UPDATE_FUTURE_PRICE,
  DELETE_FUTURE_PRICE,
} from "./constants";
import { getAuthUserId, toCreatorRef } from "../utils/ids";

export const getAllItems = () => async (dispatch) => {
  try {
    
    dispatch({ type: START_LOADING });
    const { data } = await api.fetchItems();
    // console.log(data)
    dispatch({ type: FETCH_ITEMS, payload: data });
    dispatch({ type: END_LOADING });
  } catch (error) {
    console.log(error);
  }
};
export const getItemsByUser = (searchQuery) => async (dispatch) => {
  try {
    dispatch({ type: START_LOADING });
    const {
      data: { data },
    } = await api.fetchItemsByUser(searchQuery);
    dispatch({ type: FETCH_ITEMS_USER, payload: data });
    dispatch({ type: END_LOADING });
  } catch (error) {
    console.log("getItemsByuser in itemActions error");
    console.log(error.response);
  }
};

// export const createItem = (item, openSnackbar) => async (dispatch) => {
//   try {
//     const { data } = await api.addItem(item);
//     dispatch({ type: ADD_NEW_ITEM, payload: data });

//     // Check if stock.quantity and stock.unit are defined
//     if (data.units?.stock?.quantity && data.units?.stock?.unit) {
//       const { initialStockdata } = await api.addStock([
//         {
//           item: data.id,
//           transactionType: "MASTER",
//           qty: data.units.stock.quantity,
//           unit: data.units.stock.unit,
//           categoryId: data.category.categoryId,
//           createdAt: data.createdAt,
//           references: {
//             transactionRef: "Stock",
//           },
//           creator: data.creator || "65549a5b77d1c64130b5db0c",
//         },
//       ]);
//       dispatch({ type: ADD_NEW_STOCK, payload: initialStockdata });
//     }

//     openSnackbar("Item added successfully");
//   } catch (error) {
//     console.log(error);
//   }
// };

// actions/itemActions.js
export const createItem = (item, openSnackbar) => async (dispatch) => {
  try {
    console.log("Item data sent to api.addItem:", item);
    const { data } = await api.addItem(item);
    console.log("Response from api.addItem:", data);
    dispatch({ type: ADD_NEW_ITEM, payload: data });
    openSnackbar("Item added successfully");

    // After item creation, add stock if toggleStock is true
    if (item.toggleStock && item.units?.stock?.quantity && item.units?.stock?.unit) {
      console.log("Triggering stock addition for item:", data.id);
      dispatch(addStockForItem(data, item.units.stock, openSnackbar));
    } else {
      console.log("No stock transaction needed: toggleStock is false or stock data missing");
    }

    return data; // Return the created item for potential use
  } catch (error) {
    console.error("Error in createItem:", error.message, error.stack);
    openSnackbar("Failed to add item: " + error.message);
    throw error; // Re-throw to handle in the caller if needed
  }
};

// actions/itemActions.js (or a new file like stockActions.js)
export const addStockForItem = (item, stockData, openSnackbar) => async (dispatch) => {
  try {
    const stockTransaction = {
      item: item.id,
      transactionType: "MASTER",
      qty: parseFloat(stockData.quantity),
      unit: stockData.unit,
      categoryId: item.category.categoryId,
      createdAt: item.createdAt,
      references: { transactionRef: "Stock" },
      creator: toCreatorRef(item.creator) ?? getAuthUserId(),
    };
    console.log("Stock data to be sent to api.addStock:", stockTransaction);

    const response = await api.addStock([stockTransaction]); // Get full response
    const stockDataResponse = response.data; // Extract data
    console.log("Response from api.addStock:", stockDataResponse);

    const payload = Array.isArray(stockDataResponse) ? stockDataResponse : [stockDataResponse];
    dispatch({ type: ADD_NEW_STOCK, payload });
    openSnackbar("Stock transaction added successfully");
  } catch (error) {
    console.error("Error in addStockForItem:", error.message, error.stack);
    openSnackbar("Failed to add stock transaction: " + error.message);
    throw error;
  }
};

const stockDetailsItems = (cartItems) => {
  const stockItems = cartItems
    .filter(
      (data) =>
        data.units?.stock?.quantity && data.units?.stock?.unit // Filter only valid items
    )
    .map((data) => ({
      item: data.id,
      transactionType: "MASTER",
      qty: data.units.stock.quantity,
      unit: data.units.stock.unit,
      categoryId: data.category.categoryId,
      createdAt: data.createdAt,
      references: {
        transactionRef: "Stock",
      },
      creator: toCreatorRef(data.creator) ?? getAuthUserId(),
    }));

  return stockItems;
};

export const createItems = (items, openSnackbar) => async (dispatch) => {
  try {
    const { data } = await api.addItems(items);
    dispatch({ type: ADD_NEW_ITEMS, payload: data });

    // Filter and call addStock only if valid items exist
    const validStockItems = stockDetailsItems(data);
    if (validStockItems.length > 0) {
      const { data: initialStockdata } = await api.addStock(validStockItems);
      dispatch({ type: ADD_NEW_STOCKS, payload: initialStockdata });
    }

    openSnackbar("Items added successfully");
  } catch (error) {
    console.log(error);
    throw error;
  }
};

// Creates MASTER stock transactions for items that already existed and were
// updated (bulk upload "update existing item" path), which otherwise never
// gets a stock transaction the way newly-created items do via createItems().
export const addStockForItems = (items, openSnackbar) => async (dispatch) => {
  try {
    const validStockItems = stockDetailsItems(items);
    if (validStockItems.length === 0) return;

    const { data: initialStockdata } = await api.addStock(validStockItems);
    dispatch({ type: ADD_NEW_STOCKS, payload: initialStockdata });
  } catch (error) {
    console.error("Error in addStockForItems:", error.message, error.stack);
    openSnackbar("Failed to add stock transaction: " + error.message);
    throw error;
  }
};
// export const createItems = (item, openSnackbar) => async (dispatch) => {
//   try {
//     const { data } = await api.addItems(item);
//     dispatch({ type: ADD_NEW_ITEM, payload: data });

//     const { initialStockdata } = await api.addStock([
//       {
//         itemName: data.itemName,
//         transactionRef: "Item Master",
//         qty: data.stockQty.initialQty,
//         unitPrice: data.unitPrice,
//         categoryId: data.category.categoryId,
//         itemId: data.id,
//         createdAt: data.createdAt,
//       },
//     ]);
//     dispatch({ type: ADD_NEW_STOCK, payload: initialStockdata });

//     openSnackbar("Item added successfully");
//   } catch (error) {
//     console.log(error);
//   }
// };
export const updateItem = (id, item, openSnackbar) => async (dispatch) => {
  try {
    console.log("Inside updateItems Function in react", item);

    const { data } = await api.updateItem(id, item);
    dispatch({ type: UPDATE_ITEM, payload: data });
    openSnackbar("Item updated successfully");
  } catch (error) {
    console.log(error);
  }
};
// export const updateItems = (items, openSnackbar) => async () => {
//   try {
//     console.log("Inside updateItems Function in react", items);
//     ;
//     const { message } = await api.updateItems(items);

//     openSnackbar(message);
//   } catch (error) {
//     console.log(error);
//   }
// };

export const updateItems = (items, openSnackbar) => async (dispatch) => {
  try {
    console.log("Inside updateItems Function in react", items);
    const response = await api.updateItems(items);
    if (!response || !response.data) {
      throw new Error("No valid response from server");
    }
    const { data } = response;
    items.forEach((item) => {
      dispatch({ type: UPDATE_ITEM, payload: item });
    });
    openSnackbar(data.message || "Items updated successfully");
  } catch (error) {
    console.error("Error in updateItems:", error);
    openSnackbar("Failed to update items: " + (error.message || "Unknown error"));
    throw error;
  }
};
export const deleteItem = (id, openSnackbar) => async (dispatch) => {
  try {
    await api.deleteItem(id);
    dispatch({ type: DELETE_ITEM, payload: id });
    openSnackbar("Item deleted successfully");
  } catch (error) {
    console.log(error);
  }
};
export const deleteItemsByCategoryId = (id, openSnackbar) => async (dispatch) => {
  
  try {
    await api.deleteItemsByCategoryId(id);
    dispatch({ type: DELETE_ITEMS_BY_CATEGORY, payload: id });
    openSnackbar("Items deleted successfully with category");
  } catch (error) {
    console.log(error);
  }
};

// export const getItemById = (id) => async (dispatch) => { // For specific item lookup
//   try {
//     const { data } = await api.fetchItemById(id);
//     return data;
//   } catch (error) {
//     console.log(error);
//     return null;
//   }
// };


export const toggleItemStatus = (id) => async (dispatch) => {
  try {
    const { data } = await api.toggleItemStatus(id);
    dispatch({ type: UPDATE_ITEM, payload: data });
    dispatch(getAllItems());

    return { success: true };
  } catch (error) {
    console.log(error);
    return { success: false, message: error.message };
  }
};

export const createFuturePriceList = (futurePriceList, openSnackbar) => async (dispatch) => {
  try {
    dispatch({ type: START_LOADING });
    const { data } = await api.createFuturePriceList(futurePriceList);
    dispatch({ type: CREATE_FUTURE_PRICE_LIST, payload: data });
    dispatch({ type: END_LOADING });

    const hasUpdates = data.some((result) => result.updated);
    const message = hasUpdates
      ? "Future price list scheduled successfully (some prices updated)"
      : "Future price list scheduled successfully";
    openSnackbar(message);
  } catch (error) {
    console.error("Error creating future price list:", error);
    openSnackbar("Failed to create future price list: " + error.message);
    throw error;
  }
};

export const fetchFuturePriceList = () => async (dispatch) => {
  try {
    dispatch({ type: START_LOADING });
    const { data } = await api.fetchFuturePriceList();
    dispatch({ type: FETCH_FUTURE_PRICE_LIST, payload: data });
    dispatch({ type: END_LOADING });
  } catch (error) {
    console.error("Error fetching future price list:", error);
    throw error;
  }
};

// export const updateFuturePrice = (id, priceData, openSnackbar) => async (dispatch) => {
//   try {
//     dispatch({ type: START_LOADING });
//     const { data } = await api.updateFuturePrice(id, priceData);
//     dispatch({ type: UPDATE_FUTURE_PRICE, payload: data });
//     dispatch({ type: END_LOADING });
//     openSnackbar("Future price updated successfully");
//   } catch (error) {
//     console.error("Error updating future price:", error);
//     openSnackbar("Failed to update future price: " + error.message);
//     throw error;
//   }
// };

export const updateFuturePrice = (id, priceData, openSnackbar) => async (dispatch) => {
  try {
    console.log("Updating future price with payload:", { id, priceData });
    dispatch({ type: "START_LOADING" });
    const { data } = await api.updateFuturePrice(id, priceData);
    console.log("Update future price response:", data);
    dispatch({ type: "UPDATE_FUTURE_PRICE", payload: data });
    dispatch({ type: "END_LOADING" });
    openSnackbar("Future price updated successfully");
  } catch (error) {
    console.error("Error updating future price:", error);
    openSnackbar("Failed to update future price: " + error.message);
    throw error;
  }
};

export const deleteFuturePrice = (id, openSnackbar) => async (dispatch) => {
  try {
    dispatch({ type: START_LOADING });
    await api.deleteFuturePrice(id);
    dispatch({ type: DELETE_FUTURE_PRICE, payload: id });
    dispatch({ type: END_LOADING });
    openSnackbar("Future price deleted successfully");
  } catch (error) {
    console.error("Error deleting future price:", error);
    openSnackbar("Failed to delete future price: " + error.message);
    throw error;
  }
};

